// gf_gym_agents' public endpoint (see its docs/DEPLOYING_WEBSOCKET.md).
const DEPLOYED_AGENT_WS_URL = "wss://agents.bgbehavior.com/ws/agent";
const LOCAL_SIMULATOR_WS_URL = "ws://localhost:8787";

/**
 * Agent repo's WebSocket URL. REACT_APP_AI_AGENT_WS_URL wins when set; otherwise a page served
 * from localhost talks to the local simulator (same check firebase.js uses for its emulator),
 * and anything else talks to the deployed agent server.
 */
export function getAiAgentWsUrl() {
  if (process.env.REACT_APP_AI_AGENT_WS_URL) return process.env.REACT_APP_AI_AGENT_WS_URL;
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  return hostname === "localhost" || hostname === "127.0.0.1" ? LOCAL_SIMULATOR_WS_URL : DEPLOYED_AGENT_WS_URL;
}

// The mission whose timeline is running, set by jehliGearshiftTask.js as each mission starts.
// Online builds have no REACT_APP_MISSION_NUMBER (setting it switches to local metadata), so this
// is the only place the mission number comes from there.
let runningMissionNumber = null;
const missionListeners = new Set();

/** Called when a mission's timeline starts; notifies listeners (the socket) on a change. */
export function setAiAgentMissionNumber(missionNumber) {
  if (!Number.isInteger(missionNumber) || missionNumber === runningMissionNumber) return;
  runningMissionNumber = missionNumber;
  missionListeners.forEach((listener) => listener(missionNumber));
}

/** @param {(missionNumber: number) => void} listener @returns {() => void} unsubscribe */
export function onAiAgentMissionChange(listener) {
  missionListeners.add(listener);
  return () => missionListeners.delete(listener);
}

/**
 * The running mission as an integer, or null. process.env values are always strings, and the
 * agent repo rejects a string missionNumber ("0") on session.start and on every state. The
 * env value is only a fallback for dev runs before the mission's timeline starts.
 */
export function getAiAgentMissionNumber() {
  if (runningMissionNumber !== null) return runningMissionNumber;
  const raw = process.env.REACT_APP_MISSION_NUMBER;
  if (raw == null || raw === "") return null;
  const missionNumber = Number(raw);
  return Number.isInteger(missionNumber) ? missionNumber : null;
}
